import InlineRestClient from 'inline-rest-client';

let url = '/backend';
if(document.location.host.includes('localhost')){
    url = 'http://localhost:8080/';
}
export const Api = new InlineRestClient({
    url,
    parameterType: 'json',
    defaultMethod: 'post',
    headers: {'x-token': localStorage.getItem('token')}
});
